import React, { useState } from 'react'
import { Tabs, Tab } from '@mui/material'
import { TabContext, TabPanel } from '@mui/lab'
import logo from '../../../../src/assets/img/logos/ariane-fse.png'
import MssTable from '@components/tables/MssTable'
import MssRequestsTable from '@components/tables/MssRequestsTable'
import InboxIcon from '@mui/icons-material/Inbox'
import EventNoteIcon from '@mui/icons-material/EventNote'

export default function Mss() {
  const [value, setValue] = useState(0)

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <>
      <TabContext value={value.toString()}>
        <div>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="mss tabs"
            sx={{
              backgroundColor: 'white',
              minHeight: '48px',
              '& .MuiTab-root': {
                minHeight: '48px',
                padding: '6px 12px',
                fontSize: '0.875rem',
              },
              '& .MuiTab-iconWrapper': {
                marginRight: '8px',
              },
            }}
          >
            <Tab
              icon={<InboxIcon />}
              iconPosition="start"
              label="Emails"
              {...a11yProps(0)}
            />
            <Tab
              icon={<EventNoteIcon />}
              iconPosition="start"
              label="Demandes"
              {...a11yProps(1)}
            />
          </Tabs>
          <TabPanel value="0">
            <MssTable />
          </TabPanel>
          <TabPanel value="1">
            <MssRequestsTable />
          </TabPanel>
        </div>
      </TabContext>
      <div className="absolute rounded-full top-6 right-6 -translate-y-1/2">
        <img src={logo} alt="logo" style={{ width: '176px' }} />
      </div>
    </>
  )
}
